import axios from "axios";
import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { authAPI } from "../../apis";
import SplashScreen from "../../layout/SplashScreen";

const EmailConfirm = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    async function getData() {
      try {
        const res = await axios.get(authAPI.confirmEmail, {
          params: {
            userId: searchParams.get("userId"),
            code: searchParams.get("code"),
          },
        });

        if (res.data) {
          toast.success("Email has been successfully confirmed");
          navigate("/");
        }
      } catch (error) {
        if (
          String(error.response.data).toLowerCase() ===
          "User Already Confirmed the email".toLowerCase()
        ) {
          toast.success("Email has already been confirmed");
          navigate("/signin");
        } else {
          console.log(error);
          toast.error("Some error occured. Please try again!");
        }
      }
    }

    getData();
  }, []);

  return (
    <div className="email-confirm">
      <SplashScreen />
    </div>
  );
};

export default EmailConfirm;
